import styled from "styled-components";

export const DateContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const Day = styled.div`
  font-size: 17px;
  //   font-weight: bold;
  font-style: normal;
  color: #c2c2c2;
`;
export const Hour = styled.div`
  font-size: 22px;
  font-weight: bold;
  font-style: normal;
`;
